module.exports = __webpack_public_path__ + "img/logo-6.1a77bcb2.png";